import Layout from "../../components/Layout";
import Head from "next/head";
// import Link from "next/link";
import { useEffect } from "react";
import ReactGA from "react-ga";
import { useRouter } from "next/router";
import sanitize from "../../helpers/sanitize";
import axiosInstance from "../../config/axios";

const termsAndCondition = ({ tandc, tandc_banner }) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const createMarkup = (html) => ({ __html: sanitize(html) });
  const router = useRouter();
      const canonicalUrl = `https://kilimanjaro-restaurants.com${router.asPath.split('?')[0]}`;
        

  return (
    <Layout>
      <Head>
        <link rel="canonical" href={canonicalUrl} />
        <title>Terms and Conditions | Kilimanjaro Restaurants </title>
         <meta
            name="description"
            content="Read the Kilimanjaro Restaurants Terms and Conditions, including the rules and policies that apply to orders, payments, delivery, promotions, and the use of our services."
          />

          <meta name="keyword" content="MEALS FOOD RESTAURANT NIGERIA" />
      </Head>
     <header className="store-header tandc">
  <img
    src={tandc_banner}
    alt=""
    className="img-fluid"
    loading="eager"
  />
</header>
      <section className="contact-us store-location about tandc">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h4 className="mb-3">Terms and Conditions</h4>
            </div>
            <div className="col-md-10 mx-auto">
              <div dangerouslySetInnerHTML={createMarkup(tandc)}></div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

termsAndCondition.getInitialProps = async () => {
  try {
    const {
      data: {
        data: { tandc, tandc_banner },
      },
    } = await axiosInstance.get("settings");
    return { tandc, tandc_banner };
  } catch (e) {
    // console.log(e);
    return {};
  }
};

export default termsAndCondition;
